import { hexToRGBA } from '../../utils';
import { grey } from './colors';
const greyLight = hexToRGBA(grey[80], 0.4);
const greyDark = hexToRGBA(grey[80], 0.6);
const modal = hexToRGBA('#000000', 0.15);
export default {
    '0': `0 0 0 0 #fff`,
    '1': `0 2px 5px 0 ${greyLight}`,
    '2': `0 4px 12px 0 ${greyLight}`,
    '3': `0 7px 20px 0 ${greyDark}`,
    '4': `0 12px 30px 0 ${greyDark}`,
    t1: `0 -2px 5px 0 ${greyLight}`,
    t2: `0 -4px 12px 0 ${greyLight}`,
    t3: `0 -7px 20px 0 ${greyDark}`,
    t4: `0 -12px 30px 0 ${greyDark}`,
    r1: `2px 0 5px 0 ${greyLight}`,
    r2: `4px 0 12px 0 ${greyLight}`,
    r3: `7px 0 20px 0 ${greyDark}`,
    r4: `12px 0 30px 0 ${greyDark}`,
    l1: `-2px 0 5px 0 ${greyLight}`,
    l2: `-4px 0 12px 0 ${greyLight}`,
    l3: `-7px 0 20px 0 ${greyDark}`,
    l4: `-12px 0 30px 0 ${greyDark}`,
    modal: `0 12px 30px 0 ${modal}`
};
